import { useEffect, useRef, useState } from 'react';
import { League, useLeague } from '../context/LeagueContext';
import { useUser } from '../context/UserContext';
import { signInWithGoogle, auth } from '../firebase';
import { useNavigate, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import {
  FaBars,
  FaTimes,
  FaCogs,
  FaSignOutAlt,
} from 'react-icons/fa';
import './GlobalHeader.css';
import { FaChevronDown } from 'react-icons/fa6';
import { LEAGUE_OPTIONS } from '../const/leagues';

export default function GlobalHeader() {
  const { league, setLeague } = useLeague();
  const { user } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [animating, setAnimating] = useState('')
  const [isMobile, setIsMobile] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [leagueDropdownOpen, setLeagueDropdownOpen] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleNavClick = (path: string) => {
    navigate(path);
    setTimeout(() => {
      setMobileNavOpen(false);
    }, 10); // allow click to propagate first
  };
  
  
  const handleLogin = async () => {
    try {
      const result = await signInWithGoogle();
      const token = await result.user.getIdToken();
      localStorage.setItem('token', token);
    } catch (err) {
      console.error('Login error:', err);
    }
  };

  const handleLogout = async () => {
    console.log('logout??' )
    try {
      await signOut(auth);
      localStorage.removeItem('token');
      window.location.reload();
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  // useEffect(() => {
  //   const handleClickOutside = (event: MouseEvent) => {
  //     const target = event.target as Node;
  
  //     if (
  //       dropdownRef.current &&
  //       !dropdownRef.current.contains(target)
  //     ) {
  //       setMobileNavOpen(false);
  //       setMenuOpen(false);
  //     }
  //   };
  
  //   // Use "mousedown" for mobile reliability
  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);

  

  useEffect(() => {
    setAnimating(`slot-${league}`);
    const timeout = setTimeout(() => setAnimating(''), 600); // match animation duration
    return () => clearTimeout(timeout);
  }, [league]);

  return (
    <header className="global-header">
      <div className="header-left" onClick={() => navigate('/')}>
        <h1 className="app-name">
        <div 
        className={`logo-img ${animating || `logo-img--${league}`}`}
        title="HypeScore Logo">

        </div>
        <div className='title'>
          Hype<span>Score</span>
        </div>
        </h1>
      </div>

      <div className="header-center">
        <div className="league-select-wrapper">
        <div className="league-select-dropdown" onClick={() => setLeagueDropdownOpen(!leagueDropdownOpen)}>
          <div className="league-selected">
            <span>{LEAGUE_OPTIONS[league].label}</span>
            <FaChevronDown className="chevron" />
          </div>

          {leagueDropdownOpen && (
            <div className="league-options">
              {Object.entries(LEAGUE_OPTIONS)
                .filter(([key]) => key !== league)
                .map(([key, { label }]) => (
                  <div
                    key={key}
                    className="league-option"
                    onClick={() => {
                      setLeague(key as League);
                      setLeagueDropdownOpen(false);
                    }}
                  >
                    <span>{label}</span>
                  </div>
              ))}

            </div>
          )}
        </div>

          {/* <select
            value={league}
            onChange={(e) => setLeague(e.target.value as any)}
            className="league-select"
          >
            {Object.entries(LEAGUE_OPTIONS).map(([key, { label }]) => (
              <option key={key} value={key}>
                {label}
              </option>
            ))}
          </select> */}
        </div>
      </div>

      <div className="header-spacer" />

      <div className="hamburger" onClick={() => setMobileNavOpen(!mobileNavOpen)}>
        {mobileNavOpen ? <FaTimes /> : <FaBars />}
      </div>

      <nav ref={dropdownRef} className={`header-right ${mobileNavOpen ? 'open' : ''}`}>
        <div className="nav-links">
          <span
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
            onClick={() => handleNavClick('/')}
          >
            Leaderboard
          </span>
          <span
            className={`nav-link ${location.pathname === '/games' ? 'active' : ''}`}
            onClick={() => handleNavClick('/games')}
          >
            Live Matchups
          </span>
          <span
            className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
            onClick={() => handleNavClick('/about')}
          >
            About
          </span>
        </div>

        <div className="user-section">
        {user ? (
          <div className="user-section">
            {isMobile ? (
              <div className="user-expanded">
                <img src={user.photoURL} alt="avatar" className="user-avatar" />
                <div className="user-info">
                  <p className="user-name">{user.displayName}</p>
                  <p className="user-email">{user.email}</p>
                  <div className="user-settings">
                    <span onClick={() => handleNavClick('/settings')}><FaCogs /> Settings</span>
                    <span onClick={() => { console.log("Logging out..."); handleLogout(); }}><FaSignOutAlt />Sign out</span>

                  </div>
                </div>
              </div>
            ) : (
              <div className="user-dropdown-container">
                <button
                  className="user-avatar-btn"
                  onClick={() => setUserMenuOpen((prev) => !prev)}
                >
                  <img src={user.photoURL} alt="avatar" className="user-avatar" />
                </button>
                {userMenuOpen && (
                  <div className="user-dropdown">
                    <p>{user.displayName}</p>
                    <p className="user-email">{user.email}</p>
                    <div className="user-settings">
                      <span onClick={() => handleNavClick('/settings')}><FaCogs /> Settings</span>
                      <span onClick={() => { console.log("Logging out..."); handleLogout(); }}><FaSignOutAlt />Sign out</span>

                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <span className="nav-link auth-button" onClick={handleLogin}>
            Sign in with Google
          </span>
        )}

        </div>
      </nav>
    </header>
  );
}
